<template>
  <Listbox :model-value="modelValue" @update:model-value="emit('update:modelValue', $event)">
    <div class="relative">
      <ListboxButton class="select flex w-40 items-center justify-between gap-2 text-left">
        <span class="truncate">{{ selectedLabel }}</span>
        <span class="text-[10px] text-gray-400" aria-hidden="true">▼</span>
      </ListboxButton>

      <ListboxOptions class="absolute left-0 top-full z-50 mt-1 w-48 rounded-md border border-gray-200 bg-white py-1 shadow-lg focus:outline-none">
        <ListboxOption v-for="option in options" :key="option.value" v-slot="{ active, selected }" :value="option.value" as="template">
          <li class="flex cursor-pointer items-center gap-2 px-3 py-1.5 text-sm" :class="{ 'bg-gray-50': active, 'font-medium text-gray-900': selected, 'text-gray-700': !selected }">
            <span class="w-3 text-blue-700" aria-hidden="true">{{ selected ? '✓' : '' }}</span>
            {{ option.label }}
          </li>
        </ListboxOption>
      </ListboxOptions>
    </div>
  </Listbox>
</template>

<script setup lang="ts">
  import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/vue';
  import { computed } from 'vue';

  const props = defineProps<{
    modelValue: string;
    options: { value: string; label: string }[];
  }>();

  const emit = defineEmits<{ 'update:modelValue': [value: string] }>();

  const selectedLabel = computed(() => props.options.find((option) => option.value === props.modelValue)?.label ?? props.modelValue);
</script>
